var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleC"},[_c('i'),_c('h1',[_vm._v(_vm._s(_vm.textc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }